import {
  GET_PRODUCTTAG,
  GET_PRODUCTTAG_SUCCESS,
  GET_PRODUCTTAG_FAIL,
  DELETE_PRODUCTTAG,
  DELETE_PRODUCTTAG_SUCCESS,
  DELETE_PRODUCTTAG_FAIL,
  UPDATE_PRODUCTTAG,
  UPDATE_PRODUCTTAG_SUCCESS,
  UPDATE_PRODUCTTAG_FAIL,
  ADD_NEW_PRODUCTTAG,
  ADD_PRODUCTTAG_SUCCESS,
  ADD_PRODUCTTAG_FAIL,
  PRODUCTTAG_LOADING,
} from "./actionType";

export const getProductTagSuccess = (actionType, data) => ({
  type: GET_PRODUCTTAG_SUCCESS,
  payload: { actionType, data },
});

export const getProductTagFail = (actionType, error) => ({
  type: GET_PRODUCTTAG_FAIL,
  payload: { actionType, error },
});

export const getProductTag = data => ({
  type: GET_PRODUCTTAG,
  payload: data,
});

export const getProductTagLoading = () => ({
  type: PRODUCTTAG_LOADING
});

export const deleteProductTag = data => ({
  type: DELETE_PRODUCTTAG,
  payload: data,
});

export const deleteProductTagSuccess = data => ({
  type: DELETE_PRODUCTTAG_SUCCESS,
  payload: data,
});

export const deleteProductTagFail = error => ({
  type: DELETE_PRODUCTTAG_FAIL,
  payload: error,
});

export const updateProductTag = data => ({
  type: UPDATE_PRODUCTTAG,
  payload: data,
});

export const updateProductTagFail = error => ({
  type: UPDATE_PRODUCTTAG_FAIL,
  payload: error,
});

export const updateProductTagSuccess = data => ({
  type: UPDATE_PRODUCTTAG_SUCCESS,
  payload: data,
});

export const addNewProductTag = data => ({
  type: ADD_NEW_PRODUCTTAG,
  payload: data,
});

export const addProductTagSuccess = data => ({
  type: ADD_PRODUCTTAG_SUCCESS,
  payload: data,
});

export const addProductTagFail = error => ({
  type: ADD_PRODUCTTAG_FAIL,
  payload: error,
});